module.exports = __webpack_public_path__ + "static/media/051-rocket.fa17872b.svg";